export var WirepasRole;
(function (WirepasRole) {
    WirepasRole["Sink"] = "SINK";
    WirepasRole["Headnode"] = "HEADNODE";
    WirepasRole["Subnode"] = "SUBNODE";
    WirepasRole["Advertiser"] = "ADVERTISER";
})(WirepasRole || (WirepasRole = {}));
export var GatewayMode;
(function (GatewayMode) {
    GatewayMode["Velavu"] = "VLV_BACKEND";
    GatewayMode["Wirepas"] = "WIREPAS_BACKEND";
    GatewayMode["Disabled"] = "DISABLED";
})(GatewayMode || (GatewayMode = {}));
export var ScannerMode;
(function (ScannerMode) {
    ScannerMode["Disabled"] = "DISABLED";
    ScannerMode["Periodic"] = "PERIODIC";
    ScannerMode["Continuous"] = "CONTINUOUS";
})(ScannerMode || (ScannerMode = {}));
//# sourceMappingURL=device-config.js.map